import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-all-trainings-modal',
  templateUrl: './all-trainings-modal.component.html',
  styleUrls: ['./all-trainings-modal.component.scss'],
})
export class AllTrainingsModalComponent {
  @Input() isOpen: boolean = false;
  @Input() courses: any[] = [];
  @Input() learningMaps: any[] = [];
  @Output() close = new EventEmitter<void>();

  courseColumns: any[] = [
    { field: 'name', header: 'Course Name', align: 'left' },
    { field: 'optional', header: 'Optional', align: 'center' },
  ];
  learningMapColumns: any[] = [
    { field: 'name', header: 'Learning Map', align: 'left' },
    { field: 'optional', header: 'Optional', align: 'center' },
  ];

  get courseRows(): any[] {
    return this.courses.map((c: any) => ({
      name: c.course.name,
      optional: c.optional ? 'Yes' : 'No',
    }));
  }

  get learningMapRows(): any[] {
    return this.learningMaps.map((lm: any) => ({
      name: lm.learningMap.name,
      optional: lm.optional ? 'Yes' : 'No',
    }));
  }
}
